import React from "react";
import {
  Slider,
  SliderTrack,
  SliderFilledTrack,
  SliderThumb,
} from "@chakra-ui/react";

interface SliderProps {
  min: number;
  max: number;
  defaultValue: number;
  value: number;
  onChange: (value: number) => void;
  step: number;
  className?: string;
  color?: string;
}

const ParrotSlider: React.FC<SliderProps> = ({
  min,
  max,
  defaultValue,
  value,
  onChange,
  step,
  color,
}) => {
  return (
    <div className="flex flex-col items-center justify-center w-4/5">
      <Slider
        min={min}
        max={max}
        defaultValue={defaultValue}
        value={value}
        size={"lg"}
        onChange={onChange}
        step={step}
        className="w-full"
      >
        <SliderTrack bg="var(--color-grey-light)" h="1.5" rounded={"full"}>
          <SliderFilledTrack bg={color || "var(--color-blue)"} />
        </SliderTrack>
        <SliderThumb
          boxSize={5}
          _focus={{ boxShadow: "none" }}
          border="1px solid var(--color-grey-light)"
        />
      </Slider>
    </div>
  );
};

export default ParrotSlider;
